import React from "react";

import { UserOrderResponse } from "@/api";


export interface OrderDetailsViewProps {
  value: UserOrderResponse;
}

export default function OrderDetailsView({
  value,
}: OrderDetailsViewProps) {
  return (
    <section className="rounded-xl border bg-white p-6">
      {/* -----------------------------------------
          HEADER
      ----------------------------------------- */}
      {/* -----------------------------------------
          VALUES
      ----------------------------------------- */}

      <div className="grid gap-6 md:grid-cols-3">
        <Detail
          label="Requestor Name"
          value={value.requestor_name}
        />

        <Detail
          label="Requestor Email"
          value={value.requestor_email}
        />

        <Detail
          label="Requestor Phone"
          value={value.requestor_phone}
        />
      </div>
    </section>
  );
}

/*
 * --------------------------------------------------
 * DETAIL
 * --------------------------------------------------
 */

interface DetailProps {
  label: string;
  value: unknown;
}

function Detail({
  label,
  value,
}: DetailProps) {
  return (
    <div>
      <div className="mb-1 text-sm font-medium text-gray-500">
        {label}
      </div>

      <div className="text-sm font-medium text-gray-900">
        {displayValue(value)}
      </div>
    </div>
  );
}

/*
 * --------------------------------------------------
 * HELPERS
 * --------------------------------------------------
 */

function displayValue(
  value: unknown,
): string {
  if (
    value === null ||
    value === undefined
  ) {
    return "—";
  }

  const text = String(value).trim();

  return text || "—";
}